// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6935865d","977":"0f3eafab"}[chunkId] + ".chunk.js";
};